<template>
<div>
    <headline>
        <i class="fa fa-calculator mr-2"></i> Zusammenfassung
        <template slot="more">
            <button-white v-show="datePick ==='2021-09' || datePick ==='2021-10' || datePick ==='2021-11' || datePick ==='2021-12' || datePick ==='2022-01'">
                <i class="fa fa-download mr-2"></i>
                Report
            </button-white>
        </template>
    </headline>
    <monthspicker @date="load" :date="current"></monthspicker>
    <div  v-show="datePick ==='2021-09' || datePick ==='2021-10' || datePick ==='2021-11' || datePick ==='2021-12' || datePick ==='2022-01'">
        <h2 class="text-lg leading-6 font-medium text-gray-900">Monatsübersicht</h2>
    <div class="grid grid-cols-2 grid-flow-col gap-4 mb-10 mt-10">
        <div class="ml-10 bg-white w-96 rounded-lg">
            <div>
                <select id="location" name="location" class="mt-3 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                    <option>1. Etage</option>
                    <option selected>2. Etage</option>
                    <option>3. Etage</option>
                </select>
            </div>
        <div class="hidden sm:block p-4">
            <div class="border-b border-gray-200">
            <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
                <a href="#" class="border-transparent text-sm leading-6 font-medium text-gray-900 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2">
                    <i class="fa fa-building mr-2" aria-hidden="true"></i>
                <span @click="switchArea">Bereichsauslastung</span>
                </a>

                <a href="#" class="border-transparent text-sm leading-6 font-medium text-gray-900 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2">
                    <i class="fa fa-desktop mr-2" aria-hidden="true"></i>
                <span @click="switchDesk">Arbeitsplatzsauslastung</span>
                </a>
            </nav>
            </div>
        </div>

        <img v-show="datePick ==='2021-09' && !deskPick" class="object-scale-down rounded-lg" src="/files/office012021.png" alt="">
        <img v-show="datePick ==='2021-09' && deskPick" class="object-scale-down rounded-lg" src="/files/officeDesk012021.png" alt="">
        <img v-show="datePick ==='2021-10' && !deskPick" class="object-scale-down rounded-lg" src="/files/office022021.png" alt="">
        <img v-show="datePick ==='2021-10' && deskPick" class="object-scale-down rounded-lg" src="/files/officeDesk022021.png" alt="">
        <img v-show="datePick ==='2021-11' && !deskPick" class="object-scale-down rounded-lg" src="/files/office032021.png" alt="">
        <img v-show="datePick ==='2021-11' && deskPick" class="object-scale-down rounded-lg" src="/files/officeDesk032021.png" alt="">
        <img v-show="datePick ==='2021-12' && !deskPick" class="object-scale-down rounded-lg" src="/files/office042021.png" alt="">
        <img v-show="datePick ==='2021-12' && deskPick" class="object-scale-down rounded-lg" src="/files/officeDesk042021.png" alt="">
        <img v-show="datePick ==='2022-01' && !deskPick" class="object-scale-down rounded-lg" src="/files/office052021.png" alt="">
        <img v-show="datePick ==='2022-01' && deskPick" class="object-scale-down rounded-lg" src="/files/officeDesk052021.png" alt="">
        
        
        </div>
        <div>
            <div class="grid grid-cols-1 gap-5">
                <!-- Card -->

                <div class="bg-white overflow-hidden shadow rounded-lg w-3/4 ">
                    <div class="p-5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: outline/scale -->
                                <i class="fa fa-hourglass-half fa-2x" aria-hidden="true"></i>
                            </div>
                            <div class="ml-5 w-0 flex-1">
                                <dl>
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        Durchschnittliche Auslastung
                                    </dt>
                                    <dd>
                                        <div v-show="datePick ==='2021-09'" class="text-lg font-medium text-gray-900"> 69,23 % </div>
                                        <div v-show="datePick ==='2021-10'" class="text-lg font-medium text-gray-900"> 80 %</div>
                                        <div v-show="datePick ==='2021-11'" class="text-lg font-medium text-gray-900"> 91,3 %</div>
                                        <div v-show="datePick ==='2021-12'" class="text-lg font-medium text-gray-900"> 85,36 %</div>
                                        <div v-show="datePick ==='2022-01'" class="text-lg font-medium text-gray-900"> 90,48 %</div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-5 py-3">
                        <div class="text-sm">
                            <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                                Details
                            </a>
                        </div>
                    </div>
                </div>

                <div class="bg-white overflow-hidden shadow rounded-lg w-3/4">
                    <div class="p-5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: outline/scale -->
                                <i class="fa fa-ticket fa-2x" aria-hidden="true"></i>
                            </div>
                            <div class="ml-5 w-0 flex-1">
                                <dl>
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        Durchschnittliche Arbeitsplatznutzung vom Nutzer
                                    </dt>
                                    <dd>
                                        <div v-show="datePick ==='2021-09'" class="text-lg font-medium text-gray-900"> 9,2 Tage</div>
                                        <div v-show="datePick ==='2021-10'" class="text-lg font-medium text-gray-900"> 13,9 Tage </div>
                                        <div v-show="datePick ==='2021-11'" class="text-lg font-medium text-gray-900"> 14,7 Tage </div>
                                        <div v-show="datePick ==='2021-12'" class="text-lg font-medium text-gray-900"> 11,7 Tage </div>
                                        <div v-show="datePick ==='2022-01'" class="text-lg font-medium text-gray-900"> 13,8 Tage </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-5 py-3">
                        <div class="text-sm">
                            <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                                Details
                            </a>
                        </div>
                    </div>
                </div>
            

                <div class="bg-white overflow-hidden shadow rounded-lg w-3/4">
                    <div class="p-5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: outline/scale -->
                                <i class="fa fa-arrows-h fa-2x"></i>
                            </div>
                            <div class="ml-5 w-0 flex-1">
                                <dl>
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        Verhältnis Nutzer zu Arbeitsplatz
                                    </dt>
                                    <dd>
                                        <div v-show="datePick ==='2021-09'" class="text-lg font-medium text-gray-900"> 1,7 </div>
                                        <div v-show="datePick ==='2021-10'" class="text-lg font-medium text-gray-900"> 1,7 </div>
                                        <div v-show="datePick ==='2021-11'" class="text-lg font-medium text-gray-900"> 1,7 </div>
                                        <div v-show="datePick ==='2021-12'" class="text-lg font-medium text-gray-900"> 1,5 </div>
                                        <div v-show="datePick ==='2022-01'" class="text-lg font-medium text-gray-900"> 1,7 </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-5 py-3">
                        <div class="text-sm">
                            <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                                Details
                            </a>
                        </div>
                    </div>
                </div>

                <div class="bg-white overflow-hidden shadow rounded-lg w-3/4">
                    <div class="p-5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: outline/scale -->
                                <i class="fa fa-users fa-2x"></i>
                            </div>
                            <div class="ml-5 w-0 flex-1">
                                <dl>
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        Nutzer(innen)
                                    </dt>
                                    <dd>
                                        <div v-show="datePick ==='2021-09'" class="text-lg font-medium text-gray-900"> 40 </div>
                                        <div v-show="datePick ==='2021-10'" class="text-lg font-medium text-gray-900"> 42 </div>
                                        <div v-show="datePick ==='2021-11'" class="text-lg font-medium text-gray-900"> 43 </div>
                                        <div v-show="datePick ==='2021-12'" class="text-lg font-medium text-gray-900"> 43 </div>
                                        <div v-show="datePick ==='2022-01'" class="text-lg font-medium text-gray-900"> 44 </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-5 py-3">
                        <div class="text-sm">
                            <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                                Details
                            </a>
                        </div>
                    </div>
                </div>

                <div class="bg-white overflow-hidden shadow rounded-lg w-3/4">
                    <div class="p-5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: outline/scale -->
                                <i class="fa fa-desktop fa-2x"></i>
                            </div>
                            <div class="ml-5 w-0 flex-1">
                                <dl>
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        Anzahl Arbeitsplätze
                                    </dt>
                                    <dd>
                                        <div v-show="datePick ==='2021-09'" class="text-lg font-medium text-gray-900"> 24 </div>
                                        <div v-show="datePick ==='2021-10'" class="text-lg font-medium text-gray-900"> 25 </div>
                                        <div v-show="datePick ==='2021-11'" class="text-lg font-medium text-gray-900"> 28 </div>
                                        <div v-show="datePick ==='2021-12'" class="text-lg font-medium text-gray-900"> 25 </div>
                                        <div v-show="datePick ==='2022-01'" class="text-lg font-medium text-gray-900"> 26 </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-5 py-3">
                        <div class="text-sm">
                            <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                                Details
                            </a>
                        </div>
                    </div>
                </div>
            </div>
                <!-- More items... -->
        </div>
    </div>


        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 rounded-lg">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                Analyse
            </h3>

             <div v-show="datePick ==='2021-09'"> Das Büro war im September zu 69,23% ausgelastet. 
                                                  Die durchschnittliche Arbeitsplatznutzung vom Nutzer lag bei 9,2 Tagen. </div>
            <div v-show="datePick ==='2021-10'"> Das Büro war im Oktober zu 80% ausgelastet. Dies sind 11 % mehr als im Vormonat.
                                                  Die durchschnittliche Arbeitsplatznutzung vom Nutzer stieg von 9,2 Tage auf 13,9 Tage. </div>
            <div v-show="datePick ==='2021-11'"> Das Büro war im November zu 91,3% ausgelastet. Dies sind 11 % mehr als im Vormonat.
                                                  Die durchschnittliche Arbeitsplatznutzung vom Nutzer stieg von 13,9 Tage auf 14,7 Tage. </div>
            <div v-show="datePick ==='2021-12'"> Das Büro war im Dezember zu 85,36% ausgelastet. Dies sind 6 % weniger als im Vormonat.
                                                  Die durchschnittliche Arbeitsplatznutzung vom Nutzer sank von 14,7 Tage auf 11,7 Tage. </div>
            <div v-show="datePick ==='2022-01'"> Das Büro war im Januar zu 90,48% ausgelastet. Dies sind 5 % mehr als im Vormonat.
                                                  Die durchschnittliche Arbeitsplatznutzung vom Nutzer stieg von 11,7 Tage auf 13,8 Tage. </div>
                        
        </div>
    </div>
    
</div>
</template>

<script>
import Monthspicker from "../components/Monthspicker";
import Loading from "../components/UI/Loading";
import Headline from "../components/UI/Headline";
import ButtonWhite from "../components/UI/ButtonWhite";




export default {
    name: "Schedules",
    components: {
        Loading, Monthspicker, Headline, ButtonWhite,
    },

    data: () => ({
        loading: false,
        current: '',
        previous: '',
        next: '',
        datePick: '',
        deskPick: false,

    }),

    mounted() {
        this.load();
    },

    filters: {
        date(date) {
            const [y, m, d] = date.split('-');
            return date;
        },
    },

    methods: {
        switchArea() {
            return this.deskPick = false;
        },
        switchDesk() {
            return this.deskPick = true;
        },
        download() {
            window.open('/admin/schedules/export');
        },
        load(date = null) {
            this.loading = true;
            const url = '/admin/schedules' + (date ? '?date=' + date : '');
            window.axios.get(url)
                .then(result => {
                    this.loading = false;
                    this.current = result.data.current;
                    this.next = result.data.next;
                    this.previous = result.data.previous;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
                this.datePick = date;

        },
        
    },
}
</script>

<style scoped>

</style>

